/*
 * 页面路由
 */
import { lazy } from 'react';
import lazyLoad from '@c/components/lozyLoad';
import React from 'react';
import { Navigate } from 'react-router';
import i18next from 'i18next';
const Index = lazyLoad(lazy(() => import(`@m/pages/Index`)));
const ContactUs = lazyLoad(lazy(() => import(`@m/pages/ContactUs/index`)));
const AboutUs = lazyLoad(lazy(() => import(`@m/pages/AboutUs/index`)));
const PetIntroduction = lazyLoad(lazy(() => import(`@m/pages/PetIntroduction/index`)));
const InfoQuery = lazyLoad(lazy(() => import(`@m/pages/InfoQuery`)));
const PetShop = lazyLoad(lazy(() => import(`@m/pages/PetShop/index`)));

const NoMatch = lazyLoad(lazy(() => import(`@m/components/404`)));

const pageRouter: any = [
  {
    path: '',
    name: i18next.t('Layout.index.749881-14'),
    key: '',
    exact: true,
    element: Index,
  },
  {
    path: 'aboutus',
    name: i18next.t('Layout.index.749881-5'),
    key: i18next.t('AboutUs.index.745708-10'),
    element: AboutUs
  },
  {
    path: 'petIntroduction',
    name: i18next.t('Layout.index.749881-6'),
    key:  'petIntroduction',
    element: PetIntroduction,
  },
    {
    path: 'infoQuery',
    name: '信息查询',
    key:  'infoQuery',
    element: InfoQuery,
  },
  {
    path: 'petShop',
    name: i18next.t('Index.technology.260118-0'),
    key: 'petShop',
    element: PetShop,
   
  },
  {
        path: 'contactUs',
        name: '联系我们',
        key: '/contactUs',
        element: ContactUs,
  },
  {
    path: '404',
    name: '404',
    key: '/404',
    exact: true,
    hideMenu: true,
    element: NoMatch,
  },
  {
    path: '*',
    name: '404',
    key: '/404',
    hideMenu: true,
    element: <Navigate to="/404" replace />,
  },
];

export default pageRouter;
